import {
  Origin,
  type TemplateItem,
  type TemplateSection,
} from 'inspection-types';

import type { VisibilityOperationKind } from './operations';
import { resolveOrigin } from './origin';

export type QuestionPlacement = {
  question: TemplateItem;
  section: Pick<TemplateSection, 'removed'>;
};

export type SectionPlacement = Pick<TemplateSection, 'removed' | 'origin'>;

export type SectionOperationOrder<TKind extends string> = Record<
  'visible' | 'hidden',
  Record<Origin.INHERITED | Origin.LOCAL, readonly TKind[]>
>;

// Display order of the kinds a section can offer. Edit and Delete join the LOCAL lists when
// their tickets add the kinds.
const SECTION_OPERATION_ORDER: SectionOperationOrder<VisibilityOperationKind> =
  {
    visible: {
      [Origin.INHERITED]: ['hideSection'],
      [Origin.LOCAL]: ['hideSection'],
    },
    hidden: {
      [Origin.INHERITED]: ['unhideSection'],
      [Origin.LOCAL]: ['unhideSection'],
    },
  };

export function selectSectionOperations<TKind extends string>(
  order: SectionOperationOrder<TKind>,
  placement: SectionPlacement
): TKind[] {
  const state = placement.removed ? 'hidden' : 'visible';
  const origin = resolveOrigin(placement);

  return [...order[state][origin]];
}

export function offeredSectionOperations(
  placement: SectionPlacement
): VisibilityOperationKind[] {
  return selectSectionOperations(SECTION_OPERATION_ORDER, placement);
}

export function offeredQuestionOperations({
  question,
  section,
}: QuestionPlacement): VisibilityOperationKind[] {
  if (section.removed) {
    return [];
  }

  return [question.removed ? 'unhideQuestion' : 'hideQuestion'];
}
